import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { axiosInstance } from '../api/api';

export const inSyncMutation = <T>(path: string): UseMutationResult<T, Error, any, unknown> => {
  const queryClient = useQueryClient();
  return useMutation<T, Error, void, unknown>(async(): Promise<T> => {
    const result = await axiosInstance().delete(path);
    return result.data as T;
  }, {
    async onSuccess(): Promise<void> {
      await queryClient.invalidateQueries();
    }
  });
};
